<template>
    <div v-if="visible" class="grid-x align-stretch grid" :class="gridCssClass">
        <template v-for="(card) in grid.cards">
            <slot :card="card" :breakpoint="media"></slot>
        </template>
    </div>
</template>
<script>
    import Media from '../../mixins/Media';
    export default {
        mixins: [Media],
        props: {
            grid: {
                type: Object,
                default: () => { return {} }
            }
        },
        data() {
            return {
                visible: this.grid.cards && this.grid.cards.length > 0,
            }
        },
        computed: {
            gridCssClass() {
                return [
                    {
                        'grid-margin-x': !this.grid.is_collapsed,
                        'grid-margin-y': !this.grid.is_collapsed,
                        'hover': this.grid.is_hover,
                    },
                    this.grid.type,
                    'small-up-' + this.grid.columns_small,
                    'medium-up-' + this.grid.columns_medium,
                    'large-up-' + this.grid.columns_large,
                    'xlarge-up-' + this.grid.columns_xlarge,
                ]
            }
        }
    }
</script>